import React from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import LiveBrand from '../../../images/Group1.svg';

const HomeLiveExperience = () => {
  return (
    <Container className='HomeLiveExperience' fluid>
      <Container className='pt-3'>
        <Row>
          <Col>
            <img src={LiveBrand} alt='' />
          </Col>
        </Row>
      </Container>

      <Container>
        <Row>
          <Col md={7} className='HomeLiveExperience-heading'>
            <div>Live</div>
            <div>Experiences</div>
          </Col>
          <Col className='HomeLiveExperience-content mt-3'>
            <p className='pr-2'>
              Hosting live experiences under our brand, MHC Throwdown. These
              limited shows feature extensively curated lineups and unique
              production setups
            </p>
            <NavLink to='/liveExperience' className='btn btn-theam'>
              Dive in
            </NavLink>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
export default HomeLiveExperience;
